import { action, observable } from "mobx";
import { FindContract, BookingContractInfo } from "@graphql";
import { store } from "@store";

export class ContractViewerStore {
  @observable data: BookingContractInfo = null;
  @observable loading = false;
  @observable error: string;

  constructor(public readonly id: string) {
    (window as any).contractViewerStore = this;
    this.getContractData(id);
  }

  @action getContractData = async (id: string) => {
    try {
      this.loading = true;
      this.error = null;
      await FindContract.func({ id }, { fetchPolicy: "network-only" }).then((res) => {
        this.data = res.data.contract;
      });
    } catch (e) {
      store().snackbars.error(`${e}`);
      this.error = e.toString();
    } finally {
      this.loading = false;
    }
  };
}
